import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import UserChatsMenu from './UserChatsMenu/UserChatsMenu';
import AllUserChatsMenu from './AllUserChatsMenu/AllUserChatsMenu';
import UserOnline from './UserOnlineMenu/UserOnline';
import ChatService from '../../../redux-toolkit/services/chatService/chatService';
import { useDispatch, useSelector } from 'react-redux';
import { setAdminTyping, setDisconnectUsersWithMessages, setOnlineUsers, setTyping, setUsersWithMessages, stopAdminTyping, stopTyping, updateUserAllMessageSeen, updateUserMessage } from '../../../redux-toolkit/features/slices/chatSlice/chatSlice';


const ChatsMenu = () => {
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path");
  const dispatch = useDispatch();
  const { AuthInfo, AuthType } = useSelector((state) => state?.auth);
  // ========= Register user =========
  useEffect(() => {
    if (!AuthInfo?.email) return;
    ChatService.register(AuthInfo.email, AuthType);
    ChatService.listen("connect", () => {
      ChatService.register(AuthInfo.email, AuthType);
    });

    return () => ChatService.remove("connect");
  }, [AuthInfo?.email]);



  useEffect(() => {

    ChatService.listen("onlineUsers", (onlineUsers) => {
      // console.log("onlineUsers 2: ", onlineUsers)
      if (Array.isArray(onlineUsers)) {

        dispatch(setOnlineUsers({ data: onlineUsers, type: "onlineUsers" }));

      }
    });

    ChatService.listen("newUser", (list) => {
      //  console.log("newUser 2: ", list)
      if (list) {
        dispatch(setOnlineUsers({ data: list, type: "newOnlineUsers" }));
        dispatch(setUsersWithMessages(list));
      }
    });

    ChatService.listen("userListUpdate", (data) => {
      if (Array.isArray(data)) {
        dispatch(setOnlineUsers({ data: data, type: "onlineUsers" }));
      }
    });

    ChatService.listen("typing", (data) => {
      data.type === "admin" ? dispatch(setAdminTyping(data)) : dispatch(setTyping(data));
    });

    ChatService.listen("stopTyping", (data) => {
      data.type === "admin" ? dispatch(stopAdminTyping(data)) : dispatch(stopTyping(data));
    });

    // Message receive
    ChatService.listenMessage((data) => {
      const newData = data?.message;
      if (!newData?.adminId) {
        dispatch(updateUserMessage(newData));
      }
    });

    // listenMessageSeen receive
    ChatService.listenMessageSeen(({ user }) => {
      if (!user?.lastMessage?.adminId) {
        dispatch(updateUserAllMessageSeen(user));
      }

    });

    return () => {
      ChatService.remove("onlineUsers");
      ChatService.remove("newUser");
      ChatService.remove("userListUpdate");
      ChatService.remove("typing");
      ChatService.remove("stopTyping");
      ChatService.removeMessageSeenListen();
    };
  }, []);

  return (
    <>

      {path === "online" ? <UserOnline /> : path === "chats" ? <UserChatsMenu /> : <AllUserChatsMenu />}


    </>
  )
}

export default ChatsMenu